/** @format */

import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// ----------------------------------------------------------------------

export default function LogoOnlyWithToken() {
  let token = useSelector(({ auth }) => auth?.auth?.token);
  let waba = useSelector(({ waba }) => waba?.waba);
  const navigate = useNavigate();

  useEffect(() => {
    if (!waba) {
      navigate("/connectWFB", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <>
      <Outlet />
    </>
  );
}
